export enum Language {
  english = 'en',
  german = 'de',
  // spanish = 'es',
  // french = 'fr',
}
